"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultStyle = void 0;
var getDefaultStyle = function (visible) { return ({
    display: visible ? 'flex' : 'none',
}); };
exports.getDefaultStyle = getDefaultStyle;
